<template>
	<div class="navList" @mouseleave="navShow = false">
		<div>
			<!-- 导航栏组件 -->
			<div class="navFather">
				<div :class="[activeNav === index?'activeSon':'','navSon']" @click="navToPage(item)"
					@mousemove="navShow = true" @mouseenter="listTab(index)" v-for="(item,index) in navList" :key="index">
					<p>{{item.label}}</p>
				</div>
			</div>
			
			<div class="sd_header_bottom" v-show="navShow && tab">
				<div class="menu2">
					<div class="menu_tab" :style="{left:left}">
						<p v-for="(item,index) in tab" @click="navTab(item)" :key="index">{{item.label}}></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeNav: 0,
				navList: [],
				navShow: false,
				tabIndex: '',
				tab: [],
				left: '',
			}
		},
		props: {
			navlist: {
				type: Array,
				default: () => []
			},
			isfirst: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			navlist(newValue) {
				this.navList = newValue
				let urlParams = window.location.pathname.split('/')
				const arqParams = urlParams[urlParams.length - 1]
				const newIndex = newValue.findIndex((item) => item.link === arqParams)
				if ( newIndex == -1 ) {
					if(!arqParams){
						this.activeNav = 0
					}else{
						this.activeNav = ''
					}
				} else {
					this.activeNav = newIndex
				}
			}
		},
		created() {

		},
		methods: {
			// 带参数链接
			navTab(item) {
				this.navToPage(this.navList[this.tabIndex],item.label)
			},
			// 纯网页链接
			navToPage(item, detail) {
				// 检测是否为http网址
				const bool = item.link.indexOf('http') !== -1
				if (item.link.indexOf('http') !== -1) {
					window.open(item.link)
				} else {
					if (this.isfirst) {
						if (item.link !== 'index.html') {
							if (detail) {
								const link = './pages/' + item.link + '?detail=' + detail
								window.open(link, '_self')
							} else {
								const link = './pages/' + item.link
								window.open(link, '_self')
							}
						} else {
							const link = './' + item.link
							window.open(link, '_self')
						}
					} else {
						if (item.link !== 'index.html') {
							if (detail) {
								const link = './' + item.link + '?detail=' + detail
								window.open(link, '_self')
							} else {
								const link = './' + item.link
								window.open(link, '_self')
							}
						} else {
							const link = '../' + item.link
							window.open(link, '_self')
						}
					}
				}
			},
			// 展示列表
			listTab(index) {
				const mainlevel = document.getElementsByClassName('navSon')
				const detailevel = document.getElementsByClassName('menu_tab')
				// 网站首页的位置
				const firstlevel = mainlevel[0].offsetLeft

				let mainleft = mainlevel[index].offsetLeft
				let mainWidth = mainlevel[index].offsetWidth
				let midLeft = mainleft + (mainWidth / 2)
				// midLeft是父元素的位置
				this.$nextTick(() => {
					setTimeout(() => {
						// newLeft是tab元素的宽度
						let newLeft = detailevel[0].offsetWidth
						// const halfNewLeft = (newLeft/2)
						const halfNewLeft = newLeft
						if (halfNewLeft > midLeft) {
							this.left = (firstlevel - 40) + 'px'
							// this.left = '20px'
						} else {
							this.left = (midLeft - (newLeft / 2)) + 'px'
						}
					}, 0)
				})

				this.tabIndex = index
				const newChildren = this.navList[index].children
				if (newChildren.length) {
					this.tab = newChildren
				} else {
					this.tab = false
				}
			},
		}
	}
</script>

<style>
	.navList {
		width: 100%;
		height: 61px;
		background: #125DB2;
		position: relative;
	}

	/* 导航栏组件 */
	.navFather {
		width: 1200px;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.navSon {
		height: 56px;
		line-height: 56px;
		font-size: 18px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		cursor: pointer;
	}

	.activeSon {
		border-bottom: 5px solid #fff;
	}

	/* 二级悬浮 */
	.sd_header_bottom {
		width: 100%;
		height: 60px;
		background-color: #ffffff;
		position: absolute;
		opacity: 0.8;
		z-index: 999;
		top: 61px;
	}

	.menu2 {
		min-height: 60px;
		margin-left: auto;
		margin-right: auto;
	}

	.menu_tab {
		width: auto !important;
		display: flex;
		position: absolute;
		width: 100%;
	}

	.menu_tab p {
		line-height: 60px;
		font-size: 16px;
		min-width: 120px;
		text-align: center;
	}

	.menu_tab p:hover {
		color: #1890FF;
		cursor: pointer;
	}
</style>
